import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '/about-us' },
      { name: 'Products', href: '/products' },
      { name: 'Careers', href: '#' },
      { name: 'Blog', href: '/blogs' },
      { name: 'Contact Us', href: '/contact-us' }
    ],
    services: [
      { name: 'Web Development', href: '/services/web-development' },
      { name: 'Mobile Apps', href: '/services/mobile-app-development' },
      { name: 'Cloud Solutions', href: '/services/cloud-solutions' },
      { name: 'UI/UX Design', href: '/services/ui-ux-design' },
      { name: 'Data Analytics', href: '/services/data-analytics' },
      { name: 'DevOps Services', href: '/services/devops-aws-services' }
    ],
    resources: [
      { name: 'All Services', href: '/services' },
      { name: 'Our Products', href: '/products' },
      { name: 'Blog & Insights', href: '/blogs' },
      { name: 'Sitemap', href: '/sitemap' },
      { name: 'Software Dev Dubai', href: '/software-development-company-dubai' },
      { name: 'Support Center', href: '#' }
    ],
    legal: [
      { name: 'Privacy Policy', href: '#' },
      { name: 'Terms of Service', href: '#' },
      { name: 'Cookie Policy', href: '#' },
      { name: 'Security', href: '#' }
    ]
  };

  const socialLinks = [
    {
      name: 'LinkedIn',
      // href: 'https://linkedin.com/company/ascali-it-services/',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
        </svg>
      )
    },
    {
      name: 'Twitter',
      // href: 'https://twitter.com/ascali',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.74l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      )
    },
    {
      name: 'GitHub',
      // href: 'https://github.com/ascali',
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
        </svg>
      )
    }
  ];

  const renderLink = (link) => {
    if (link.href.startsWith('http') || link.href === '#') {
      return (
        <a
          href={link.href}
          target={link.href.startsWith('http') ? '_blank' : undefined}
          rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
          className="text-gray-300 hover:text-cyan-300 transition-colors text-sm"
        >
          {link.name}
        </a>
      );
    }
    return (
      <Link to={link.href} className="text-gray-300 hover:text-cyan-300 transition-colors text-sm">
        {link.name}
      </Link>
    );
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center mb-6">
                <img src="/images/Scalizap-edited.png" alt="Scalizap Logo" className="h-14 w-auto object-contain" />
              </div>
              <p className="text-gray-300 text-lg leading-relaxed mb-6 max-w-md text-left">
                Transforming businesses through innovative technology solutions. We create scalable, secure,
                and user-centric software that drives growth and digital transformation.
              </p>
              <div className="space-y-3.5 mb-8">
                {/* Aligned Location Row */}
                <div className="flex items-center text-gray-300">
                  <svg className="w-5 h-5 text-cyan-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div className="grid grid-cols-3 gap-x-4 flex-1 text-sm sm:text-base font-medium">
                    <div className="flex justify-between items-center pr-3 border-r border-slate-700/80">
                      <span>Canada</span>
                    </div>
                    <div className="flex justify-between items-center pr-3 border-r border-slate-700/80">
                      <span>India</span>
                    </div>
                    <div>
                      <span>United Arab Emirates</span>
                    </div>
                  </div>
                </div>

                {/* Aligned Phone Row */}
                <div className="flex items-center text-gray-300">
                  <svg className="w-5 h-5 text-cyan-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <div className="grid grid-cols-3 gap-x-4 flex-1 text-xs sm:text-sm">
                    <div className="flex justify-between items-center pr-3 border-r border-slate-700/80">
                      <a href="tel:+19027904113" className="hover:text-cyan-300 transition-colors whitespace-nowrap">+1 90279 04113</a>
                    </div>
                    <div className="flex justify-between items-center pr-3 border-r border-slate-700/80">
                      <a href="tel:+919633191692" className="hover:text-cyan-300 transition-colors whitespace-nowrap">+91 96331 91692</a>
                    </div>
                    <div>
                      <a href="tel:+971508032476" className="hover:text-cyan-300 transition-colors whitespace-nowrap">+971 508 032 476</a>
                    </div>
                  </div>
                </div>

                {/* Email Row */}
                <div className="flex items-center text-gray-300">
                  <svg className="w-5 h-5 text-cyan-400 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a href="mailto:info@scalizap.com" className="hover:text-cyan-300 transition-colors text-sm sm:text-base">info@scalizap.com</a>
                </div>
              </div>
              <div className="flex space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-slate-800 hover:bg-gradient-to-br hover:from-blue-500 hover:to-cyan-400 rounded-lg flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Links Columns Grouped with Right Shift */}
            <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-8 lg:pl-12">
              {/* Company Links */}
              <div>
                <h3 className="font-semibold text-lg mb-6">Company</h3>
                <ul className="space-y-3">
                  {footerLinks.company.map((link) => (
                    <li key={link.name}>{renderLink(link)}</li>
                  ))}
                </ul>
              </div>

              {/* Services Links */}
              <div>
                <h3 className="font-semibold text-lg mb-6">Services</h3>
                <ul className="space-y-3">
                  {footerLinks.services.map((link) => (
                    <li key={link.name}>{renderLink(link)}</li>
                  ))}
                </ul>
              </div>

              {/* Resources Links */}
              <div>
                <h3 className="font-semibold text-lg mb-6">Resources</h3>
                <ul className="space-y-3">
                  {footerLinks.resources.map((link) => (
                    <li key={link.name}>{renderLink(link)}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="border-t border-slate-800 py-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="font-display text-2xl font-semibold mb-3">Stay Updated with Tech Insights</h3>
              <p className="text-gray-300">Get the latest trends, best practices, and exclusive insights delivered to your inbox monthly.</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <button className="bg-gradient-to-r from-blue-500 to-cyan-400 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg whitespace-nowrap">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-slate-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-6 text-gray-400 text-sm">
              <p>© {currentYear} Scalizap. All rights reserved.</p>
              <div className="flex space-x-4">
                {footerLinks.legal.map((link) => (
                  <a key={link.name} href={link.href} className="hover:text-cyan-300 transition-colors">
                    {link.name}
                  </a>
                ))}
              </div>
            </div>
            <div className="flex items-center space-x-6 text-gray-400 text-sm">
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                <span>All systems operational</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-4 h-4 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span>Enterprise Security</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
